/* eslint-disable */
// CapitalOS — email notifications via Netlify Function + Resend
// Works silently (no errors shown to visitors) until you connect Resend.
// Setup: LaunchGuide Phase 3. Once your RESEND_API_KEY is set in Netlify,
// every enquiry and every completed Fundability assessment lands in your inbox.

async function post(payload) {
  try {
    await fetch("/.netlify/functions/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    // Silently ignore — email is a bonus channel; data is also stored locally
    console.warn("Email notification skipped:", e?.message);
  }
}

export async function notifyEnquiry(form) {
  return post({
    kind: "enquiry",
    subject: `New enquiry: ${form.name} — ${form.business || "no business name"}`,
    name: form.name, email: form.email, phone: form.phone,
    business: form.business, service: form.service, message: form.message,
  });
}

export async function notifyLead(report, answers) {
  const lead = answers.lead || {};
  const sc = report.sc || {};
  return post({
    kind: "lead",
    subject: `New Fundability lead: ${answers.q1 || "Unknown"} (${sc.overall || 0}/100${sc.hot ? " · HOT" : ""})`,
    name: `${lead.firstName || ""} ${lead.lastName || ""}`.trim(),
    email: lead.email, phone: lead.phone,
    business: answers.q1, sector: answers.q2, turnover: answers.q5,
    funding: answers.q9, urgency: answers.q8,
    score: sc.overall, pressure: sc.pressCat, hot: !!sc.hot,
    wantsReview: answers.q22 === "Yes, please contact me",
    routes: (report.rt || []).map(r => r.n).join(", "),
    insight: report.commercialInsight || "",
  });
}

export async function notifyReport(report, answers) {
  const lead = answers.lead || {};
  if (!lead.email) return;
  const sc = report.sc || {};
  return post({
    kind: "report",
    toEmail: lead.email,
    business: answers.q1 || "Your Business",
    score: sc.overall || 0,
    pressure: sc.pressCat || "",
    insight: report.commercialInsight || "",
    routes: (report.rt || []).map(r => ({ n: r.n, d: r.d })),
  });
}
